export default {
    slug: 'calendar',
    ability: 'calendar',
    routes: [
        {
            path: 'calendar',
            name: 'calendar',
            component: () => import('@modules/Calendar/Resources/js/pages/Index.vue')
        }
    ],
    generalTabs: () => [
        {
            position: 2,
            title: i18n.t('Calendar'),
            icon: 'calendar-sync',
            route: 'settings-general-calendar',
            ability: 'settings.calendar'
        }
    ],
    generalRoutes: [
        {
            path: 'calendar',
            name: 'settings-general-calendar',
            component: () => import('@modules/Calendar/Resources/js/pages/settings/CalendarSync.vue'),
            props: true
        }
    ],
    // At the top level rather than inside a domain: a task is a billable unit of
    // work on a site and a follow-up on a deal, and the calendar carries both
    // kinds of appointment. Filing either under CRM or under Operations would
    // pick a side the work does not have — and would hide it from the half of
    // the application that was not chosen. The navigation already keeps this
    // place for what belongs to everyone; the dashboard sits here too.
    nav: () => ({
        section: 'global',
        items: [
            {
                position: 3,
                title: i18n.t('Calendar'),
                icon: 'calendar',
                to: { name: 'calendar' }
            }
        ]
    }),
    widgets: () => [
        {
            id: 'upcoming-events',
            label: i18n.t('Agenda'),
            icon: 'calendar-text-outline',
            component: () => import('@modules/Calendar/Resources/js/pages/dashboards/widgets/UpcomingEvents.vue'),
            size: 'is-4',
            module: 'calendar'
        }
    ]
};
